import type { AdjustmentType } from '../enums/AdjustmentType'
import type { AdjustmentReasonMiniEntity } from '@/features/adjustmentReason/domain/entities/AdjustmentReasonMiniEntity'

export class AdjustmentEntity {
  id?: number
  amount?: number
  type?: AdjustmentType
  adjustmentReasonId?: number | null
  adjustmentReason?: AdjustmentReasonMiniEntity
  adjustmentReasonName?: string | null
  note?: string | null
  effectiveDate?: string
  driver?: {
    id?: number
    fullName?: string | null
    workingPhoneNumber?: string | null
  }
}
